import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Constants from "app_constants";
import Theme from "./theme";

const ContactView = (props) => {
  const {
    setFormData,
    submit,
    success,
    error,
    verifyCaptcha,
    name,
    email,
    message,
  } = props;

  return (
    <Theme>
      {Constants.metaTag}

      <div className="box">
        <div className="panel">
          {success && (
            <p className="success">Your message has been sent successfully!</p>
          )}
          {error && (
            <p className="error">An error occured. Please try again!</p>
          )}

          <div className="field">
            <label className="label">Name & Surname</label>
            <div className="control">
              <input
                value={name}
                onChange={(e) => {
                  setFormData("name", e.target.value);
                }}
                className="input is-info"
                placeholder="John Smith"
                type="text"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">E-mail</label>
            <div className="control">
              <input
                value={email}
                onChange={(e) => {
                  setFormData("email", e.target.value);
                }}
                className="input is-info"
                placeholder="example@remote-jobs.io"
                type="text"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Message</label>
            <div className="control">
              <textarea
                value={message}
                onChange={(e) => {
                  setFormData("message", e.target.value);
                }}
                className="textarea is-info"
                placeholder="Your message..."
              ></textarea>
            </div>
          </div>

          <ReCAPTCHA
            className="recaptcha"
            sitekey="6LdetPgUAAAAACGneGdlNfUA_UtKhKnL7riRVs62"
            onChange={verifyCaptcha}
          />

          <br />

          <button
            onClick={submit}
            className="button is-info is-fullwidth submit"
          >
            Submit
          </button>
        </div>
      </div>
    </Theme>
  );
};

export default ContactView;
